
import VideoBackground from './video/VideoBackground';

const selectors = {
	'el' : '.js-video-background',
	imageFallback : '.js-video-background__fallback',
	video : '.js-video-background__video',
	toggle : '.js-video-background__toggle'
}

function init() {

	$(selectors.el).each(function() {
		const 
			$container = $(this),
			$imageFallback = $container.find(selectors.imageFallback),
			$video = $container.find(selectors.video),
			$toggle = $container.find(selectors.toggle);

		if ($video.length) new VideoBackground($video, $imageFallback, $toggle);
	});

}

export default {
	init
}